/**
 * Language selector progressive enhancement.
 *
 * @package DemocraticTools
 */

export function initLanguageSelector() {
  const selector = document.querySelector('.dt-language-selector');
  const select = document.getElementById('dt-language-select');
  if (!selector || !select) {
    return;
  }

  selector.setAttribute('aria-label', 'Language');

  select.addEventListener('change', () => {
    const locale = select.value;
    const url = new URL(window.location.href);
    url.searchParams.delete('dt_locale_pref');

    if (locale) {
      url.searchParams.set('dt_locale_pref', locale);
    }

    window.location.href = url.toString();
  });
}
